import React, { useEffect, useState } from 'react';
import { Box, Typography, Table, TableBody, TableCell, TableHead, TableRow, Paper, Pagination, Chip, TextField } from '@mui/material';
import axios from 'axios';
import { useSelector } from 'react-redux';

export default function AuditLogs() {
  const [logs, setLogs] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filterDate, setFilterDate] = useState('');
  const auth = useSelector((state) => state?.loginState?.auth);

  useEffect(() => {
    if (auth?.token) {
      fetchLogs();
    }
  }, [page, auth, filterDate]);

  const fetchLogs = async () => {
    try {
      let url = `${process.env.REACT_APP_URL || 'http://127.0.0.1:8000/api/'}action-log/?page=${page}`;
      if (filterDate) {
        url += `&filter_by={"created_at__date":"${filterDate}"}`;
      }
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${auth.token}` }
      });
      setLogs(res.data?.data?.results || []);
      const count = res.data?.data?.count || 0;
      setTotalPages(Math.ceil(count / 10)); // Assuming pagination is 10
    } catch (err) {
      console.error(err);
    }
  };

  const getActionColor = (action) => {
    if (action === 'CREATE') return 'success';
    if (action === 'UPDATE') return 'info';
    if (action === 'DELETE') return 'error';
    return 'default';
  };

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h5" sx={{ fontWeight: 700, color: '#0f172a' }}>
          System Audit Logs
        </Typography>
        <TextField 
          type="date"
          label="Filter by Day"
          InputLabelProps={{ shrink: true }}
          size="small"
          value={filterDate}
          onChange={(e) => {
            setFilterDate(e.target.value);
            setPage(1); // Reset to page 1 on filter
          }}
          sx={{ width: 200 }}
        />
      </Box>
      <Paper elevation={0} sx={{ p: 2, border: '1px solid #e2e8f0', borderRadius: '12px' }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 700 }}>Time</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>User</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>Action</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>Module</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>Record ID</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>Details</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {logs.map((log) => (
              <TableRow key={log.id}>
                <TableCell>{new Date(log.created_at).toLocaleString()}</TableCell>
                <TableCell>{log.user_name || 'System'}</TableCell>
                <TableCell>
                  <Chip size="small" label={log.action} color={getActionColor(log.action)} />
                </TableCell>
                <TableCell>{log.model_name}</TableCell>
                <TableCell>{log.object_id || '-'}</TableCell>
                <TableCell sx={{ fontSize: 12, color: '#64748b' }}>{log.details}</TableCell>
              </TableRow>
            ))}
            {logs.length === 0 && (
              <TableRow>
                <TableCell colSpan={6} align="center" sx={{ py: 3, color: '#94a3b8' }}>
                  No audit logs found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        {totalPages > 1 && (
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
            <Pagination count={totalPages} page={page} onChange={(e, val) => setPage(val)} color="primary" />
          </Box>
        )}
      </Paper>
    </Box>
  );
}
